module.exports = __webpack_public_path__ + "img/black_pic_frame_img_not_found.00aa8e5d.jpg";